import Link from 'components/Link'
import { cn, handle } from 'common/utils'
import VoteArrowOverview from 'cc/VoteArrowOverview'

import routes from 'common/routes'
import Avatar from 'cc/Avatar'
import { useUserReviewCounts } from 'utils/hooks'

export const UserCard = ({ user, children, className }) => {
  const reviewCounts = useUserReviewCounts(user.id)

  return (
    <Link href={routes.userPath(user)}>
      <div
        className={cn(
          'flex items-center space-x-4 bg-white hover:bg-gray-50 rounded border p-3',
          className,
        )}
      >
        <div className="flex flex-col items-center space-y-2 w-[200px]">
          <Avatar size={86} user={user} />
          <div className="text-xl break-all text-gray-800">{handle(user)}</div>
        </div>

        <div className="flex flex-col items-start space-y-2 w-full">
          <div className="block">
            <span>{user.name}</span>
            {user.tagline?.length ? (
              <>
                <span className="mx-2">&middot;</span>
                <span className="text-lg text-gray-500 font-light">
                  {user.tagline}
                </span>
              </>
            ) : null}
          </div>
          {reviewCounts ? (
            <div className="mx-auto">
              <VoteArrowOverview
                reviewCounts={reviewCounts}
                className="flex space-x-4"
              />
            </div>
          ) : null}
        </div>
      </div>
    </Link>
  )
}
